<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Performance Mentor">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <a-card type="inner" size="small" style="margin-top: 24px">
            <a-skeleton :loading="loading" active>
                <a-table
                    class="pcp-table"
                    :columns="columns"
                    :dataSource="tableData"
                    rowKey="id"
                    :pagination="false"
                    bordered>

                    <div slot="photo" slot-scope="record" style="text-align: center">
                        <a-avatar :src="record.photo" shape="square" :size="64" icon="user" />
                    </div>

                    <div slot="name" slot-scope="record" style="text-align: left">
                        <h4>
                            <a-icon type="user" /> {{ record.name }} <br />
                            <a :href="`tel:${record.mobile_phone}`"><a-icon type="phone" /></a> {{ record.mobile_phone }}
                        </h4>
                    </div>

                    <div slot="recap" slot-scope="record" style="text-align: center">
                        <center>{{ record.scorer.recap }}</center>
                    </div>

                    <template slot="footer" slot-scope="record" className="column-right">
                        <a-row type="flex" justify="end">
                            <a-col :span="4">

                            </a-col>
                            <a-col :span="2">

                            </a-col>
                        </a-row>
                    </template>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
		key: 'photo',
		title: 'Foto',
        align: 'center',
		scopedSlots: {customRender: 'photo'},
	}, {
		key: 'name',
		title: 'Nama Lengkap',
        align: 'center',
		scopedSlots: {customRender: 'name'}
	}, {
		key: 'recap',
		title: 'Nilai Rekap',
        align: 'center',
		scopedSlots: {customRender: 'recap'}
	}
]

export default {
    data() {
        return {
            columns,
            loading: false,
            items: {},
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            let params = {
                user_hash: this.$laravel.user.hash,
                recap_type: 'evaluator'
            }

            this.loading = true

            this.$http
                .get(this.routeUri('api.recap.activity-score.attendants_result') + '?' + this.$qs.stringify(params))
                .then(response => this.items = response.data.attendants)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
    },
    computed: {
        tableData(){
            if(this.items.length > 0){
                let idx = 0
                let collection = []
                let idx2 = 0
                let totProject = 0
                let idxProject = 0

                this.items.forEach(function(item){
                    idx++
                    let scorer = {
                        recap: 0
                    }
                    item.evaluators.forEach(function(evaluator){
                        let scoreEvaluator = item.activities[0].evaluator_score[evaluator]

                        if(Array.isArray(scoreEvaluator) && scoreEvaluator.length > 0){
                            idx2++
                            scoreEvaluator.forEach(function(score){
                                if(score.scoreable.scoreable_type === 'module'){
                                    totProject = parseFloat(totProject) + parseFloat(score.raw_score)
                                    idxProject++
                                }
                            })

                            let project = totProject / idxProject

                            scorer['recap'] = parseFloat(project).toFixed(2)
                        }
                    })

                    collection.push({
                        id: idx,
                        name: item.name,
                        mobile_phone: item.mobile_phone,
                        scorer
                    })
                })
                return collection
            }
            return []
        }
    }
}
</script>
